import { render, staticRenderFns } from "./CThermal.vue?vue&type=template&id=23814498&scoped=true"
import script from "./CThermal.vue?vue&type=script&lang=ts"
export * from "./CThermal.vue?vue&type=script&lang=ts"
import style0 from "./CThermal.vue?vue&type=style&index=0&id=23814498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23814498",
  null
  
)

export default component.exports